"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const functions_1 = require("@/common/functions");
function default_1() {
    const rootDiv = document.getElementById('root');
    setTimeout(() => {
        rootDiv === null || rootDiv === void 0 ? void 0 : rootDiv.addEventListener('mouseover', functions_1.replaceToMain);
        rootDiv === null || rootDiv === void 0 ? void 0 : rootDiv.addEventListener('touchstart', functions_1.replaceToMain);
    }, 0);
    window.onunload = () => {
        rootDiv === null || rootDiv === void 0 ? void 0 : rootDiv.removeEventListener('mouseover', functions_1.replaceToMain);
        rootDiv === null || rootDiv === void 0 ? void 0 : rootDiv.removeEventListener('touchstart', functions_1.replaceToMain);
    };
}
exports.default = default_1;
